/**
 * App identity: the single source of truth for the product's brand name, domain,
 * public URLs, and contact address. Change the host or brand here and every
 * consumer (web SEO, share links, emails, mobile) follows.
 *
 * Not for the API base URL: that varies by environment and platform and stays in
 * each platform's api config (VITE_API_URL for web, EXPO_PUBLIC_API_URL for mobile),
 * with WEB_URL below as the production fallback.
 */

export const BRAND_NAME = 'Parlay Picker';

// Root domain the business owns (email + zone live here on Cloudflare).
export const ROOT_DOMAIN = 'infinitescriptingsolutions.com';

// Dedicated subdomain the app is served from.
export const APP_HOST = `app.${ROOT_DOMAIN}`;

// Canonical web origin, no trailing slash.
export const WEB_URL = `https://${APP_HOST}`;

// Real monitored inbox. Role aliases (support@/privacy@/legal@) can be added here
// later without churning consumers.
export const CONTACT_EMAIL = `admin@${ROOT_DOMAIN}`;

// Transactional sender; server/config/env.ts builds the FROM_EMAIL default from it.
export const NOREPLY_EMAIL = `noreply@${ROOT_DOMAIN}`;

// The mobile app's URL scheme (apps/mobile/app.json "scheme"), not a domain.
export const MOBILE_APP_SCHEME = 'parlaypicker';

export const OG_IMAGE = `${WEB_URL}/og-image.png`;
export const TWITTER_IMAGE = `${WEB_URL}/twitter-card.png`;

/** Build an absolute app URL for a path, tolerating a leading slash. */
export function webUrl(path = ''): string {
  if (!path) return WEB_URL;
  return `${WEB_URL}/${path.replace(/^\/+/, '')}`;
}
